import React, { useMemo, useState, useEffect } from 'react';

import { useMutation, useQuery, useQueryClient } from 'react-query';
import * as API from 'api';
import debounce from 'lodash/debounce';

import ArtistsTableRow from './artists-table-row';
import { PaginationControls, SearchableTable } from 'styles/table-helpers';
import ENUMS from '../../constants/ENUMS.gen.json';

import { TextField } from '@material-ui/core';

const LABEL_TITLE = 'Search by Name';

const Parties = API.Parties();

const columns = [
  {
    width: '5%',
    label: '',
  },
  {
    width: '5%',
    label: 'ID',
  },
  {
    width: '30%',
    label: 'Name',
  },
  {
    width: '30%',
    label: 'Group Name',
  },
  {
    width: '20%',
    label: 'Required Artist',
  },
  {
    width: '10%',
    label: '',
  },
];

function ArtistsTable() {
  // Search
  const [search, setSearch] = useState('');
  const debounceUpdateSearch = useMemo(() => debounce(({ target: { value } }) => updateSearch(value), 1000), []);

  const updateSearch = value => {
    setSearch(value);
    if (search) setPageIndex(0);
  };

  // Pagination
  const pageSize = 50;
  const [pageIndex, setPageIndex] = useState(0);
  const handlePageBack = () => setPageIndex(prevState => prevState - 1);
  const handlePageForward = () => setPageIndex(prevState => prevState + 1);

  // Artist Data

  const getPartyQueryName = `party-${ENUMS.PARTY_TYPE.ARTIST}`;
  const artistsQuery = useQuery([getPartyQueryName, search, pageIndex], () => {
    return Parties.getAllByType({ search, pageIndex, pageSize, type: ENUMS.PARTY_TYPE.ARTIST });
  });

  const artistData = artistsQuery?.data?.results;
  const artistTotal = artistsQuery?.data?.total;

  const totalPages = Math.ceil(artistTotal / pageSize) || 1;

  const queryClient = useQueryClient();

  // Update Artist
  const updateArtistMutation = useMutation(({ asset_party_id, data }) => Parties.updateParty(asset_party_id, data), {
    onError: error => {
      alert(error);
      updateArtistMutation.reset();
    },
    onSuccess: () => {
      queryClient.invalidateQueries([getPartyQueryName]);
    },
  });

  useEffect(() => {
    // Check if the search param is set
    const searchParam = new URLSearchParams(window.location.search).get('search');
    if (searchParam) {
      updateSearch(searchParam);
    }
  }, []);

  return (
    <SearchableTable
      TableRowComponent={ArtistsTableRow}
      columns={columns}
      results={artistData || []}
      onSave={updateArtistMutation.mutateAsync}
      isSaving={updateArtistMutation.isLoading}
      isLoading={artistsQuery?.isLoading}
      sortByFunction={a => a?.full_name?.toLowerCase()}
      paginationControls={
        <PaginationControls
          pageIndex={pageIndex}
          totalPages={totalPages}
          onBack={handlePageBack}
          onForward={handlePageForward}
        />
      }
      searchField={<TextField label={LABEL_TITLE} onChange={debounceUpdateSearch} />}
    />
  );
}

export default ArtistsTable;
